<main>
    <h1 i18n="@@BzzztKrrtErrorHeader">Bzzzt Krrt</h1>
    <h2 i18n="@@NotSoBadErrorMessage">Huch, etwas ist schiefgelaufen. Aber das ist nicht schlimm.</h2>
   
    <p class="text-center">
        <a [routerLink]="['/dashboard']" id="to_dashboard" class="btn btn-yellow" i18n="@@GoToDashboard">Zum Dashboard</a>
    </p>
</main>
